import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { Menu, MenuItem, useMediaQuery } from '@material-ui/core'
import MuiButton from '@material-ui/core/Button'
import { ImportExport } from '@material-ui/icons'

import { translate } from '_i18n'
import * as medias from 'consts/medias'
import formatter from 'services/formatter'
import { today } from 'services/utils'
import {
  collectSelectedWeightSelector,
  collectWeightSelector,
  getCollectRequest,
} from '../../store/modules/users/collections/reducer'

import {
  ButtonsContainer,
  Container,
  ContainerWeights,
  Divider,
  StyledButton,
  WeightText,
} from './styles'

import { convertJsonToXlsx } from 'utils/convert-json-to-xlsx'

// ---------------------------------------------------------------

function CollectStatusExportMenu({ loading, onPrint, onFetchData }) {
  const [anchorEl, setAnchorEl] = useState(null)

  function handleOpen(event) {
    setAnchorEl(event.currentTarget)
  }

  function handleClose() {
    setAnchorEl(null)
  }

  function handlePrint() {
    onPrint()

    handleClose()
  }

  function handleExportToExcel() {
    const data = onFetchData()

    const sheet = data.map((row) => {
      return {
        CNPJ: row.cli_cnpj,
        'Razão Social': row.cli_razao_social,
        'Cidade/UF': row.cli_cidade,
        //
        Unidade: row.cia_descricao_carreg,
        Pedido: row.cod_pedido,
        'Emitido em': row.ped_data_emissao,
        //
        Produto: row.dsc_abreviado,
        'Seu Pedido': row.ped_seupedido,
        'Quantidade Disp.': parseFloat(row.qtd_saldo_disp),
        'Peso Disp.': parseFloat(row.peso_bru_disp),
        'Pal. Disp.': row.qtd_pallet_disp,
        'Cxs Disp.': row.qtd_caixas_disp,
        Entrega: row.data_entrega,
        Frete: row.ped_tipo_frete,
        REPR: row.rep_nome,
        //
        Quantidade: parseFloat(row.qtd_saldo_pedido),
        Peso: parseFloat(row.peso_bru_pedido),
        'Pal.': row.qtd_pallet_pedido,
        Cxs: row.qtd_caixas_pedido,
        //
        Agendamento: row.id_agendamento,
      }
    })

    convertJsonToXlsx(sheet, 'Pedidos')

    handleClose()
  }

  return (
    <>
      <MuiButton
        startIcon={<ImportExport />}
        variant="outlined"
        color="primary"
        aria-controls="export-menu"
        disabled={loading}
        onClick={handleOpen}
      >
        Exportar
      </MuiButton>

      <Menu
        id="export-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handlePrint}>Imprimir</MenuItem>
        <MenuItem onClick={handleExportToExcel}>Excel</MenuItem>
      </Menu>
    </>
  )
}

// ---------------------------------------------------------------

export function CollectStatus({ onClick, onPrint, onFetchData }) {
  const sm = useMediaQuery(medias.sm)

  const dispatch = useDispatch()
  const weight = useSelector(collectWeightSelector)
  const selectedWeight = useSelector(collectSelectedWeightSelector)
  const loading = useSelector((state) => state.users.collections.loading)

  useEffect(() => {
    dispatch(getCollectRequest())
  }, [dispatch])

  const withSelectedWeight = selectedWeight > 0

  function translateWeightDescr(translateId, weight) {
    return translate('collect.weightText', {
      typeWeight: translate(translateId),
      weight: <strong>{formatter(weight).toDecimal()}</strong>,
    })
  }

  const getLoadingText = () => {
    if (sm) return 'Carregando...'
    return withSelectedWeight ? 'Incluindo na Coleta...' : 'Buscando Coleta...'
  }

  return (
    <Container>
      <ButtonsContainer>
        <StyledButton
          loading={loading}
          disabled={loading || !withSelectedWeight}
          loadingText={getLoadingText()}
          onClick={onClick}
          label={sm ? 'Incluir' : 'Incluir na Coleta'}
          className="add"
        />

        <CollectStatusExportMenu
          loading={loading}
          onPrint={onPrint}
          onFetchData={onFetchData}
        />
      </ButtonsContainer>

      <Divider />

      <ContainerWeights>
        {!sm && (
          <div>
            <span>RESUMO DA COLETA</span>
            <span className="fill">{today()}</span>
          </div>
        )}
        <div>
          <WeightText>
            {translateWeightDescr('collect.collect', weight)}
          </WeightText>
          <WeightText className="fill">
            {translateWeightDescr('collect.selected', selectedWeight)}
          </WeightText>
          <WeightText>
            {translateWeightDescr('collect.total', weight + selectedWeight)}
          </WeightText>
        </div>
      </ContainerWeights>
    </Container>
  )
}

CollectStatus.propTypes = {
  onClick: PropTypes.func,
  onPrint: PropTypes.func,
  onFetchData: PropTypes.func,
  //
  // actionLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default CollectStatus
